export default __webpack_public_path__ + "static/media/image-cover.ff60fcc7.jpg";